import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import communicationsImage from "../../resources/circa/kommunication.svg";

import "../../leading/Start.scss";


export const WelcomeCommunication = () => {
    return <div className="full-page">
        <h1><strong>Kommunikation</strong></h1>
        <img src={communicationsImage} alt="Kommunikation" />
        <div onClick={() => window.location.href = "main"} className="lower-arrow"><FontAwesomeIcon icon={faArrowRight} /></div>
    </div>;
}